
import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter,
  HashRouter,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { frFR } from '@material-ui/core/locale';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import App from './App';
import SignIn from '@features/auth/pages/SignInPage';
import { Invitations } from '@features/invitations/pages/InvitationsPage';
import Auth from '@shared/services/Auth';
import * as Sentry from '@sentry/react';

// ------------------------------------------------------------------------ //
// FONT AWESOME
// ------------------------------------------------------------------------ //
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
library.add(fas);




// ------------------------------------------------------------------------ //
// SENTRY CONFIGURATION
// ------------------------------------------------------------------------ //
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    new Sentry.BrowserTracing({
      tracePropagationTargets: ['localhost', import.meta.env.VITE_API_URL],
    }),
    new Sentry.Replay(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
});

// ------------------------------------------------------------------------ //
// REACT QUERY CONFIGURATION
// ------------------------------------------------------------------------ //
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5000,
    },
  },
});

// ------------------------------------------------------------------------ //
// PRIVATE ROUTE COMPONENT
// ------------------------------------------------------------------------ //
function PrivateRoute({ children, ...rest }) {
  const isAuth = Auth.isAuthentificated();
  console.log('[PrivateRoute] isAuthentificated:', isAuth);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuth ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/signIn",
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}


// ------------------------------------------------------------------------ //
// THEME CONFIGURATION
// ------------------------------------------------------------------------ //
const theme = createTheme(
  {
    palette: {
      primary: { main: '#213759' },
      secondary: { main: '#F8CC03' },
    },
  },
  frFR
);

// ------------------------------------------------------------------------ //
// ROOT COMPONENT
// ------------------------------------------------------------------------ //
const RouterComponent =
  window.location.protocol === 'file:' ? HashRouter : BrowserRouter;

const Root = () => (
  <QueryClientProvider client={queryClient}>
    <RouterComponent>
      <Switch>
        <PrivateRoute exact path="/">
          <App />
        </PrivateRoute>
        <Route exact path="/signIn" component={SignIn} />
        <Route exact path="/invitations" component={Invitations} />
      </Switch>
    </RouterComponent>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);

// ------------------------------------------------------------------------ //
// RENDER
// ------------------------------------------------------------------------ //

console.log('[Renderer] script exécuté');
const rootEl = document.getElementById('root');
console.log('[Renderer] root existe ?', !!rootEl);

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Root />
  </ThemeProvider>,
  document.getElementById('root')
);

